/**
 * Created by eliranm on 18/01/18.
 */
define(function (require) {
    'use strict';

    var _ = require('underscore');
    var Marionette = require('marionette');
    var template = require('templates/clickableItemView.tmpl');

    var ClickableItemView = Marionette.ItemView.extend({

        template: template,

        events: {
            'click': '_onClick'
        },

        initialize: function (options) {
            this.options = options || {};
            this._validate();
        },

        templateHelpers: function () {
            return {
                textContent: this.options.text,
            };
        },

        onRender: function () {
            this.$el.addClass('clickable');
            if (this.options.customClassName) {
                this.$el.addClass(this.options.customClassName);
            }
        },

        _validate: function () {
            if (!this.options.text || !_.isString(this.options.text)) {
                throw new Error('options.text is mandatory');
            }
            if (!this.options.onClick || !_.isFunction(this.options.onClick)) {
                throw new Error('options.onClick is mandatory');
            }
        },

        _onClick: function () {
            this.options.onClick.apply(this, arguments);
        },

    });

    return ClickableItemView;
});
